import React from 'react';

interface PlanogramComplianceTogglesProps {
  isV2: boolean;
  onIsV2Change: (isV2: boolean) => void;
  isDataFromCache?: boolean;
  showCacheIndicator?: boolean;
}

export const PlanogramComplianceToggles: React.FC<PlanogramComplianceTogglesProps> = ({
  isV2,
  onIsV2Change,
  isDataFromCache = false,
  showCacheIndicator = false,
}) => {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      {/* V2 Toggle */}
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-700">V2:</span>
        <button
          onClick={() => onIsV2Change(!isV2)}
          className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-colors ${
            isV2
              ? 'bg-blue-600 border-blue-600 text-white'
              : 'bg-white border-gray-300 hover:border-gray-400'
          }`}
          title="Toggle V2"
        >
          {isV2 && (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          )}
        </button>
      </div>

      {/* Cache Indicator */}
      {showCacheIndicator && isDataFromCache && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-amber-100 text-amber-800 rounded-md text-sm">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="font-medium">Cached Result</span>
        </div>
      )}
    </div>
  );
};
